import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Select } from "antd";

import { themeColor as color, themeColor } from "../../constant/color";
import { Button } from "../Button";
import "./styles.css";
import { getToken } from "../../utils/token";
import toast from "react-hot-toast";
import { CustomButton } from "../CustomButton";
// import MobileNav from "../MobileNav";

const TableTop = ({
  title,
  btnText,
  setAddRole,
  showAddRoleBtn,
  setAddRoleBtn,
  showAddSite,
  setAddSiteBtn,
  showMap,
  setShowMap,
  addSiteBtnText,
  showFilter,
  showLink,
  link,
  linkText,
  placeholder,
  search,
  setSearch,
  showCommandFilter,
  setCommandFilter,
  showDropDown,
  setDropDown,
  dropDown,
  selectedItem,
  setSelectedItem,
  dropDownPlaceholder,
  showAddMeter,
  setAddMeterModal,
}) => {
  const { Option } = Select;
  const [userRole, setUserRole] = useState("");
  useEffect(() => {
    (async () => {
      try {
        let role = await getToken("ampere_role");
        setUserRole(role);
      } catch (err) {
        toast.error(err.message);
      }
    })();
  }, []);

  const roleAssignee = (item) =>
    item == "Project Manager" ? true : item == "System Manager" ? true : false;

  return (
    <div className=" p-2 ">
      <div className="flex items-center justify-between ">
        <div className="font-semibold ">{title}</div>

        <div className="sm:col-span-12 md:col-span-5 lg:col-span-5 xxl:col-span-5 xl:col-span-5 flex items-center justify-end">
          {showAddRoleBtn && (
            <div className=" mx-2" style={{}}>
              <CustomButton
                onClick={() => setAddRoleBtn(true)}
                className={
                  "border-[1px] p-2 w-full bg-black text-white rounded flex items-center justify-center"
                }
              >
                <p className="m-0">Assign new role to staff</p>
              </CustomButton>
              {/* <Button
                color={color.whiteColor}
                height={"37px"}
                text={"Assign role to staff"}
              /> */}
            </div>
          )}
          {showAddSite ? (
            <div
              className="tabBtncover mx-2"
              onClick={() => setAddSiteBtn(true)}
              style={{}}
            >
              <Button
                color={color.whiteColor}
                height={"33px"}
                text={addSiteBtnText || "Add Site"}
              />
            </div>
          ) : null}

          {userRole == "Customer Manager" && showAddMeter ? (
            <div
              className="tabBtncover mx-2"
              onClick={() => setAddMeterModal(true)}
            >
              <Button
                color={color.whiteColor}
                height={"33px"}
                text={addSiteBtnText || "Assign meter"}
              />
            </div>
          ) : null}
          {showMap && (
            <div
              className="tabBtncover mx-2"
              onClick={() =>
                setShowMap((prev) => {
                  if (prev == true) {
                    return false;
                  } else {
                    return true;
                  }
                })
              }
            >
              <Button
                color={color.baseColor}
                height={"37px"}
                text={showMap ? `Show Map` : `Show table`}
              />
            </div>
          )}

          {showLink && (
            <div
              className="rounded-sm flex items-center "
              style={{
                overflow: "hidden",
                border: `1px solid ${color.btnFadeColor}`,
              }}
            >
              <div>
                <input
                  type={"text"}
                  placeholder={placeholder || ""}
                  value={search}
                  className="customer-search__input p-1 "
                  style={{}}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
              <Link
                className=" text-center p-2"
                to={`${link}`}
                style={{
                  width: "90px",
                  color: color.baseColor,
                  background: color.btnFadeColor,
                  fontSize: "13px",
                }}
              >
                Search
              </Link>
            </div>
          )}

          {showDropDown && (
            <div
              className="rounded-sm flex items-center "
              style={{
                overflow: "hidden",
                border: `1px solid ${color.btnFadeColor}`,
              }}
            >
              <Select
                style={{
                  width: 200,
                }}
                bordered
                value={selectedItem}
                placeholder={dropDownPlaceholder || ""}
                onChange={(e) => setSelectedItem(e)}
              >
                {dropDown.map((item) => (
                  <Option key={item} value={item}>
                    {item}
                  </Option>
                ))}
              </Select>
            </div>
          )}
          {showCommandFilter && (
            <div
              className="tabBtncover mx-2"
              onClick={() => setCommandFilter(true)}
            >
              <Button
                color={color.whiteColor}
                bg={color.baseColor}
                height={"37px"}
                text={"Show Filter"}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TableTop;
